import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import Form from './components/Form';
import { syncValidateData } from '../../../common/validator';

const FORM = 'categoriesForm';

const schema = Joi.object().keys({
  id: Joi.string().guid().optional(),
  name: Joi.string().min(2).required(),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: FORM,
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.router.push(props.baseUrl);
  },
  validate,
});

export default compose(
  withRouter,
  form
)(Form);

